import React, {lazy, Suspense, useContext, useEffect, useState} from 'react';
import StatusOrcamento from './StatusOrcamento';
import FaturacaoAnual from './FaturacaoAnual';
import Top30 from './Top30';

function Vendas() {
    return (
        <div>
             <div className="grid grid-cols-1 lg:grid-cols-2 py-4 gap-4">
                <div>
                    <StatusOrcamento />
                </div>
                <div>
                    <FaturacaoAnual />
                </div>
            </div>
          
                <div>
                    <Top30 />
                </div>
                
        </div>
    );
}

export default Vendas;
